import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../button";
import { faHeart as fasFaHeart } from "@fortawesome/free-solid-svg-icons";
import {
  faClockFour,
  faHeart as farFaHeart,
} from "@fortawesome/free-regular-svg-icons";
import { toast } from "react-toastify";
import fallbackImage from "../../Assets/placeholder.jpg";
import Skeleton from "react-loading-skeleton";
import { EMenuActions } from "../../store";
import { TaxActions } from "../../store/tax";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

export default function Card({
  ProductId,
  image,
  ProductName,
  description,
  time,
  Price,
  Quantity,
}) {
  let dispatch = useDispatch();
  const all_products = useSelector((state) => state.EMenu.all_products);
  const C_URL = useSelector((state) => state.Company.c_url);
  const t_id = useSelector((state) => state.Company.t_id);
  const previewItem = useSelector((state) => state.EMenu.previewItem);
  const cardViewType = useSelector((state) => state.EMenu.cardViewType);
  const loadProducts = useSelector((state) => state.EMenu.loadProducts);
  const favouriteProduct = useSelector((state) => state.EMenu.favouriteProduct);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const vatRate = useSelector((state) => state.Tax.vatRate);
  const serviceRate = useSelector((state) => state.Tax.serviceRate);
  const stateRate = useSelector((state) => state.Tax.stateRate);
  const isFavourite =
    favouriteProduct.some((favProduct) => favProduct.ProductId === ProductId) ||
    false;
  const [favoured, setFavoured] = useState(false);
  const sumOfTax = useSelector((state) => state.Tax.sumOfTax);
  const Amount =
    chargeType === "1"
      ? Number(Price)
      : Number(Price) + Number(Price * sumOfTax);

  const handleClick = () => {
    calcTax();
    dispatch(
      EMenuActions.addToCart({
        ProductId,
        image,
        ProductName,
        description,
        time,
        Price: Amount,
        Quantity: 1,
        inclusiveTax:
          Number(Price) -
          Number(Price) * (Number(vatRate + stateRate + serviceRate) / 100),
        sellPrice: Number(Price),
      })
    );
    toast.success("Successfully Added to tray 👍 ", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  const calcTax = () => {
    // const tax = ;
    // dispatch(TaxActions.setSumOfTax(((Number(vatRate) + Number(stateRate) + Number(serviceRate))/100)));
  };
  const [imageUrl, setImageUrl] = useState(
    `https://${C_URL}/storage/uploads/tenant/${t_id}/product/${image}`
  );
  const handleImageError = () => {
    setImageUrl(fallbackImage);
  };
  const handlePreview = () => {
    const filteredProducts = all_products.filter(
      (product) => product.productid === ProductId
    );

    if (filteredProducts.length > 0) {
      dispatch(EMenuActions.setPreviewedItem(filteredProducts[0]));
    } else {
      console.error("No product found with the given ProductId");
      return;
    }

    setTimeout(
      () => dispatch(EMenuActions.setPreviewItem((prev) => !prev)),
      1000
    );
  };

  const formatAmount = Amount.toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });

  useEffect(() => {
    if (isFavourite) {
      setFavoured(true);
    }
  }, [favoured, favouriteProduct]);
  //DO NOT ADD TO THE USE EFFECT VOLATILE CODE

  const addToFavourite = () => {
    setFavoured((prevFavoured) => !prevFavoured);
    // console.log(favoured);
    if (!favoured) {
      dispatch(
        EMenuActions.setAddFavouriteProduct({
          ProductId,
          image,
          ProductName,
          description,
          time,
          Price: Price,
        })
      );
      toast.success("Successfully Added to Favourite 👍 ", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      dispatch(
        EMenuActions.unsetFavouriteProduct({
          ProductId,
          image,
          ProductName,
          description,
          time,
          Price: Number(Price),
        })
      );
      toast.success("Successfully removed from Favourite ", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  return (
    <div onClick={handlePreview}>
      {cardViewType === "grid" ? (
        <div
          key={ProductName}
          className="bg-white rounded-xl p-4 shadow-xl cursor-pointer shadow-dark-500/10"
        >
          <div className={`text-end ${loadProducts ? "hidden" : ""}`}>
            <FontAwesomeIcon
              icon={favoured ? fasFaHeart : farFaHeart}
              size="lg"
              className={`${
                favoured ? "text-[#FF8096]" : "text-secondary"
              } hover:text-[#FF8096] hover:scale-110`}
              onClick={addToFavourite}
            />
          </div>
          {loadProducts ? (
            <Skeleton height={156} />
          ) : (
            <div className="w-full h-[150px] overflow-hidden mt-3">
              <img
                src={imageUrl}
                alt={ProductName}
                onError={handleImageError}
                className="w-full object-cover h-full rounded mx-auto"
                onClick={handlePreview}
              />
            </div>
          )}
          <div className={`text-center mt-1`}>
            <>
              {loadProducts ? (
                <Skeleton height={10} />
              ) : (
                <h3
                  className="text-sm mt-2 leading-4 text-dark font-normal md:h-12 text-ellipsis line-clamp-2 h-[4ch]"
                  onClick={handlePreview}
                >
                  {ProductName}
                </h3>
              )}

              <p
                onClick={handlePreview}
                className="text-gray-600 uppercase text-dark text-[11px] font-bold tracking-wider mt-2"
              >
                {" "}
                {time === undefined ? null : (
                  <FontAwesomeIcon
                    icon={faClockFour}
                    className="text-secondary"
                  />
                )}
                {time}
              </p>
              {loadProducts ? (
                <Skeleton height={30} />
              ) : (
                <div className="text-center">
                  <p
                    className="text-lg my-1 font-extrabold tracking-tighter text-dark"
                    onClick={handlePreview}
                  >
                    {formatAmount}
                  </p>
                  <p
                    className={` hidden md:block lg:block p-1 w-full text-primary text-xs capitalize text-center bg-primary/10 font-light tracking-tighter`}
                  >
                    Click to preview items
                  </p>
                </div>
              )}
            </>
          </div>
        </div>
      ) : (
        <div
          key={ProductName}
          className="bg-white flex flex-row gap-3 items-center place-content-center rounded-xl p-2 shadow-xl cursor-pointer shadow-dark-500/10"
        >
          <div className="w-[15%] h-[15%] max-sm:w-[30%] rounded-md overflow-hidden">
            {loadProducts ? (
              <Skeleton height={156} />
            ) : (
              <div className="w-full h-[100px]">
                <img
                  src={imageUrl}
                  alt={ProductName}
                  onError={handleImageError}
                  className="w-full h-full object-cover"
                  onClick={handlePreview}
                />
              </div>
            )}
          </div>

          <div className={`mt-1 w-[60%]`}>
            <>
              {loadProducts ? (
                <Skeleton height={10} />
              ) : (
                <h3
                  className="text-sm mt-2 leading-4 text-dark font-normal md:h-12 text-ellipsis line-clamp-2 h-[4ch]"
                  onClick={handlePreview}
                >
                  {ProductName}
                </h3>
              )}

              <p
                onClick={handlePreview}
                className="text-gray-600 uppercase text-dark text-[11px] font-bold tracking-wider mt-2"
              >
                {" "}
                {time === undefined ? null : (
                  <FontAwesomeIcon
                    icon={faClockFour}
                    className="text-secondary"
                  />
                )}
                {time}
              </p>
              {loadProducts ? (
                <Skeleton height={30} />
              ) : (
                <div>
                  <p
                    className="sm:text-lg lg:text-xl my-1 font-extrabold text-dark tracking-tighter"
                    onClick={handlePreview}
                  >
                    {formatAmount}
                  </p>
                </div>
              )}
            </>
            {/* )} */}
          </div>
          <div
            className={`w-[25%] flex flex-col gap-8 items-end px-4 ${
              loadProducts && "hidden"
            }`}
          >
            <FontAwesomeIcon
              icon={favoured ? fasFaHeart : farFaHeart}
              size={18}
              className={`${
                favoured ? "text-[#FF8096]" : "text-secondary"
              } hover:text-[#FF8096] hover:scale-110`}
              onClick={addToFavourite}
            />
            <p
              className={` hidden md:block text-primary lg:block p-1 w-full text-xs capitalize text-center bg-primary/10 font-light tracking-tighter`}
            >
              Click to preview item
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
